import { render, staticRenderFns } from "./OrgManager.vue?vue&type=template&id=6b26de62&scoped=true&"
import script from "./OrgManager.vue?vue&type=script&lang=js&"
export * from "./OrgManager.vue?vue&type=script&lang=js&"
import style0 from "./OrgManager.vue?vue&type=style&index=0&id=6b26de62&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b26de62",
  null
  
)

export default component.exports